import { DateTime } from "luxon";

export const getSequentialDays = (start: DateTime, dayCount: number): DateTime[] => {
  return Array(dayCount)
    .fill(null)
    .map((_n, i) => start.plus({ days: i }));
};
